import './DataCircle.scss'
import { Spinner } from "react-bootstrap";



const DataCircle = (props: { refresh: boolean, title: string, data: number, color: number, units: string }) => {


    const getColor = () => {
        switch (props.color) {
            case 1:
                return 'var(--IDGreen)'
            case 2:
                return 'var(--IDRed)'
            case 3:
                return 'var(--accent-color)'
            default:
                return 'var(--accent-color)'
        }
    }

    return (
        <>
            <div className="dataCircleContainer m-1 p-0 rounded-1 d-flex flex-column overflow-hidden h-100">
                <p className="my-1 h6 text-truncate w-100 text-center mt-2">{props.title}</p>
                {props.refresh ?
                    <div className="text-center pt-5"><Spinner animation="border" style={{ color: 'var(--IDBlue)' }} /></div> :
                    <div className='row gx-0 circleContainer'>
                        <div className='col d-flex justify-content-center align-items-center'>
                            <div className="dataCircle">
                                <svg viewBox="0 0 100 100" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
                                    <circle stroke={getColor()} fill="transparent" strokeWidth="5" r="40" cx="50" cy="50" />
                                </svg>
                                <div className='position-absolute'>
                                    <span className='dataCircleText text-center '>{`${props.data}`}</span>
                                    <span className='dataCircleUnits text-center'>{`${props.units}`}</span>
                                </div>
                            </div>
                        </div>
                    </div>}
            </div >
        </>
    )
}
export default DataCircle